import { useDispatch } from 'react-redux'
import { actions } from '../scrollContainerSlice'

export const useSetScrollbarVisibility = () => {
  const dispatch = useDispatch()

  return (isVisible: boolean) => dispatch(actions.setScrollbarVisibility(isVisible))
}
